import * as React from 'react';

import * as styles from './PromoItemIcon.css';
import { PROMO_ICON } from '../../constants/promoIcon';
import { IPromo } from '../../types/newbuilding/promos';

interface IPromoItemIconProps {
  promo: IPromo;
}

export function PromoItemIcon({ promo }: IPromoItemIconProps) {
  const { promoType } = promo;

  const icon = PROMO_ICON.get(promoType);

  return (
    <div className={styles['container']}>
      <div className={styles['icon']}>
        <img src={icon} alt="logo" />
      </div>
    </div>
  );
}
